import axios from "axios";

export const postData = (link, data) => axios.post(link, data, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}`, 'Access-Control-Allow-Origin': '*' } });
export const getData = (link) => axios.get(link, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
